import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logout.png'


const _withScopeId = n => (_pushScopeId("data-v-42f54e7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { id: "header" }
const _hoisted_4 = { class: "header_wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%"}
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "logo" }, "META HEALTH", -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { id: "stress_layer" }
const _hoisted_10 = { class: "stress_box" }
const _hoisted_11 = { class: "surveyWrap" }
const _hoisted_12 = { class: "survey_title" }
const _hoisted_13 = { class: "surveySelectBox" }
const _hoisted_14 = {
  key: 0,
  class: "stress_bar"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stress_bar_count" }, [
  /*#__PURE__*/_createElementVNode("b", null, "0"),
  /*#__PURE__*/_createElementVNode("b", null, "50"),
  /*#__PURE__*/_createElementVNode("b", null, "100")
], -1))
const _hoisted_16 = { style: {"display":"flex"} }
const _hoisted_17 = ["name", "value"]
const _hoisted_18 = { style: {"margin-left":"10px"} }
const _hoisted_19 = { class: "survey_radio_box" }
const _hoisted_20 = { style: {"display":"flex"} }
const _hoisted_21 = ["name", "value"]
const _hoisted_22 = { style: {"margin-left":"10px"} }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "btn_wrap" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSlider = _resolveComponent("VueSlider")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              style: {"left":"29px","height":"54px"},
              class: "menu_btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.backToList && $setup.backToList(...args)))
            }, _hoisted_6),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString($setup.currentQuestion.no) + ". " + _toDisplayString($setup.currentQuestion.title), 1),
                _createElementVNode("div", _hoisted_13, [
                  ($setup.currentQuestion.type === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_VueSlider, {
                          modelValue: $setup.answer['content' + ($setup.result.currentPage + 1)],
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.answer['content' + ($setup.result.currentPage + 1)]) = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_15
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.currentQuestion.type === 1)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.currentQuestion.choiceList, (option, optIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "survey_radio",
                          key: optIndex
                        }, [
                          _createElementVNode("label", _hoisted_16, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              name: 'question' + $setup.currentQuestion.idx,
                              value: option.idx,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.answer['content' + ($setup.result.currentPage + 1)]) = $event))
                            }, null, 8, _hoisted_17), [
                              [_vModelRadio, $setup.answer['content' + ($setup.result.currentPage + 1)]]
                            ]),
                            _createElementVNode("p", _hoisted_18, _toDisplayString(option.title), 1)
                          ])
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  ($setup.currentQuestion.type === 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", null, _toDisplayString($setup.currentQuestion.leftContent), 1),
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentQuestion.choiceList, (option, optIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "survey_radio",
                              style: {"margin":"10px 0"},
                              key: optIndex
                            }, [
                              _createElementVNode("label", _hoisted_20, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  name: 'question' + $setup.currentQuestion.idx,
                                  value: option.idx,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.answer['content' + ($setup.result.currentPage + 1)]) = $event))
                                }, null, 8, _hoisted_21), [
                                  [_vModelRadio, $setup.answer['content' + ($setup.result.currentPage + 1)]]
                                ]),
                                _createElementVNode("p", _hoisted_22, _toDisplayString(option.title), 1)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", null, _toDisplayString($setup.currentQuestion.rightContent), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  ($setup.currentQuestion.type === 3)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 3,
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.answer['content' + ($setup.result.currentPage + 1)]) = $event)),
                        placeholder: $setup.currentQuestion.title,
                        style: {"border":"1px solid","width":"100%"}
                      }, null, 8, _hoisted_23)), [
                        [_vModelText, $setup.answer['content' + ($setup.result.currentPage + 1)]]
                      ])
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              ($setup.result.currentPage !== 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "submit_btn",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.prevQuestion && $setup.prevQuestion(...args)))
                  }, " 이전 "))
                : _createCommentVNode("", true),
              ($setup.result.currentPage === $setup.survey.list.length - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "submit_btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.checkSurvey && $setup.checkSurvey(...args))),
                    disabled: $setup.isNextDisabled
                  }, " 제출하기 ", 8, _hoisted_25))
                : _createCommentVNode("", true),
              ($setup.result.currentPage !== $setup.survey.list.length - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "submit_btn",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.nextQuestion && $setup.nextQuestion(...args))),
                    disabled: $setup.isNextDisabled
                  }, " 다음 ", 8, _hoisted_26))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}